import React from 'react';
import { MeatballMenu } from 'ui';

import styles from './list-remove-all.scss';

interface ListRemoveAllProps {
  label: string;
  onClick: () => void;
}

export const ListRemoveAll: React.FC<ListRemoveAllProps> = ({ label, onClick }) => {
  return <div className={styles.meatballBar}>
    <MeatballMenu closeAfterClick={true}>
      <li>
        <button type="button" className="dropdown-item" onClick={onClick}>
          {label}
        </button>
      </li>
    </MeatballMenu>
  </div>;
};
